var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p-child',{staticClass:"p-tab-content",attrs:{"namespace":"p-tab-content"}},[(_vm.internalActive)?[_vm._t("default")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }